import { css } from '@emotion/react'

export const truncate = (numberOfLinesToTruncate = 2) => css`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${numberOfLinesToTruncate};
  -webkit-box-orient: vertical;
  height: auto;
  max-height: initial;
`
